import { atom } from "recoil";

const pathState = atom({
  key: "pathState",
  default: {
    currentPath: null,
    previousPath: null,
    PerviousTitle:"",
    CurrentTitle:""
  },
});

export default pathState;